import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AppStateProvider } from './contexts/AppState';
import { AppShell } from './components/layout/AppShell';
import { WorkQueue } from './pages/WorkQueue';
import { Configuration } from './pages/Configuration';
import { Reporting } from './pages/Reporting';
import { OfficerDetail } from './pages/OfficerDetail';
import { LeadList } from './pages/LeadList';
import { LeadDetail } from './pages/LeadDetail';
interface AppProps {
  /** Layout of the Loan Officer workspace: alongside the upcoming queue, or full-width focus mode. */
  workspaceLayout?: 'split' | 'focused';
}
export function App({
  workspaceLayout = 'split'
}: AppProps) {
  return <AppStateProvider data-id="element-0" data-mp="2whx8rm2ytac0">
      <BrowserRouter data-id="element-1" data-mp="28ufoebm15ej2">
        <Toaster position="bottom-right" richColors closeButton data-id="element-2" data-mp="28tmfb3zlmcxr" />
        <AppShell data-id="element-3" data-mp="28s30zixi6bym">
          <Routes data-id="element-4" data-mp="23vkzcrxgytqi">
            <Route path="/" element={<Navigate to="/queue" replace data-id="element-6" data-mp="23utb6267bya9" />} data-id="element-5" data-mp="23u9t8lgjx9w8" />
            <Route path="/queue" element={<WorkQueue layout={workspaceLayout} data-id="element-8" data-mp="3iiwf2oflbi38" />} data-id="element-7" data-mp="3ik7fce9tu7pl" />
            <Route path="/configuration" element={<Configuration data-id="element-10" data-mp="3mkrcviybbdc9" />} data-id="element-9" data-mp="3ii4ppvcl6gle" />
            <Route path="/reporting" element={<Reporting data-id="element-12" data-mp="3rc9dg5wfbbwp" />} data-id="element-11" data-mp="3mjq1tehaqquj" />
            <Route path="/reporting/officer/:officerId" element={<OfficerDetail data-id="element-14" data-mp="3recbnd7qcbci" />} data-id="element-13" data-mp="3rbzo8kj7d8s2" />
            <Route path="/reporting/officer/:officerId/source/:sourceId" element={<LeadList data-id="element-16" data-mp="7suzhf7pr6a" />} data-id="element-15" data-mp="6hrlipoilfp" />
            <Route path="/reporting/lead/:leadId" element={<LeadDetail data-id="element-18" data-mp="2zmo7vf30ox5a" />} data-id="element-17" data-mp="2zllff2q1qmn9" />
            <Route path="*" element={<Navigate to="/queue" replace data-id="element-20" data-mp="33m5cy7ej7s9x" />} data-id="element-19" data-mp="2znfy0adui2o6" />
          </Routes>
        </AppShell>
      </BrowserRouter>
    </AppStateProvider>;
}